import { Text } from '@user-portal/wikr-components';
import React from 'react';

import * as S from './MealMacros.styled';

type MealMacrosProps = {
    calories?: number;
    carbs?: number;
    protein?: number;
    fat?: number;
    copy: {
        disclaimer: string;
        calories: string;
        protein: string;
        carbs: string;
        fat: string;
        measurement: string;
    };
};

export const MealMacros = ({ calories, carbs, protein, fat, copy }: MealMacrosProps) => (
    <>
        <S.Container data-locator="meal-macros" data-testid="meal-macros">
            <S.Item>
                <Text type="medium-text" bold>
                    {calories}
                </Text>
                <Text type="option-subtitle-text" color="text-secondary">
                    {copy.calories}
                </Text>
            </S.Item>
            <S.Item>
                <Text type="medium-text" bold>
                    {protein} {copy.measurement}
                </Text>
                <Text type="option-subtitle-text" color="text-secondary">
                    {copy.protein}
                </Text>
            </S.Item>
            <S.Item>
                <Text type="medium-text" bold>
                    {carbs} {copy.measurement}
                </Text>
                <Text type="option-subtitle-text" color="text-secondary">
                    {copy.carbs}
                </Text>
            </S.Item>
            <S.Item>
                <Text type="medium-text" bold>
                    {fat} {copy.measurement}
                </Text>
                <Text type="option-subtitle-text" color="text-secondary">
                    {copy.fat}
                </Text>
            </S.Item>
        </S.Container>
        <Text type="option-subtitle-text" color="text-secondary" mt={8}>
            {copy.disclaimer}
        </Text>
    </>
);
